var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 48,
    viewBox: "0 0 200 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.716 20.672C80.716 21.8107 80.4547 22.856 79.932 23.808C79.4093 24.7413 78.6067 25.4973 77.524 26.076C76.4413 26.6547 75.0973 26.944 73.492 26.944H70.524V34H65.736V14.344H73.492C75.06 14.344 76.3853 14.6147 77.468 15.156C78.5507 15.6973 79.3627 16.444 79.904 17.396C80.4453 18.348 80.716 19.44 80.716 20.672ZM73.128 23.136C74.0427 23.136 74.724 22.9213 75.172 22.492C75.62 22.0627 75.844 21.456 75.844 20.672C75.844 19.888 75.62 19.2813 75.172 18.852C74.724 18.4227 74.0427 18.208 73.128 18.208H70.524V23.136H73.128ZM87.9967 14.344V34H83.2087V14.344H87.9967ZM103.506 34L99.5025 27.98L95.9745 34H90.5425L96.8425 24.004L90.4025 14.344H95.9745L99.9225 20.28L103.394 14.344H108.826L102.582 24.256L109.078 34H103.506ZM116.27 18.18V22.156H122.682V25.852H116.27V30.164H123.522V34H111.482V14.344H123.522V18.18H116.27ZM131.419 30.304H137.691V34H126.631V14.344H131.419V30.304ZM150.696 30.304H156.968V34H145.908V14.344H150.696V30.304ZM171.488 30.528H164.152L162.976 34H157.964L165.076 14.344H170.62L177.732 34H172.664L171.488 30.528ZM170.256 26.832L167.82 19.636L165.412 26.832H170.256ZM191.796 23.92C192.935 24.1627 193.849 24.732 194.54 25.628C195.231 26.5053 195.576 27.5133 195.576 28.652C195.576 30.2947 194.997 31.6013 193.84 32.572C192.701 33.524 191.105 34 189.052 34H179.896V14.344H188.744C190.741 14.344 192.3 14.8013 193.42 15.716C194.559 16.6307 195.128 17.872 195.128 19.44C195.128 20.5973 194.82 21.5587 194.204 22.324C193.607 23.0893 192.804 23.6213 191.796 23.92ZM184.684 22.296H187.82C188.604 22.296 189.201 22.128 189.612 21.792C190.041 21.4373 190.256 20.924 190.256 20.252C190.256 19.58 190.041 19.0667 189.612 18.712C189.201 18.3573 188.604 18.18 187.82 18.18H184.684V22.296ZM188.212 30.136C189.015 30.136 189.631 29.9587 190.06 29.604C190.508 29.2307 190.732 28.6987 190.732 28.008C190.732 27.3173 190.499 26.776 190.032 26.384C189.584 25.992 188.959 25.796 188.156 25.796H184.684V30.136H188.212Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29883 43.824L24.6186 25.0991V11.6407L31.8983 2.72119L31.9148 25.0991L49.6211 42.6087V43.824H47.8936V46.7497H30.1646V43.824H6.29883Z",
    fill: "url(#paint0_linear_1198_6591)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1994 25.8425L9.09968 34.8252L0 43.8078H1.81994H6.06645L15.1661 34.8252L24.2658 25.8425H18.1994Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05809 43.7725H29.959V47.9999L5.02803e-07 47.9999L0 43.762L6.05809 43.7725Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8352 34.7791L49.9349 43.7618H29.8223V47.9998H49.9349H56.0014V43.7618L46.9017 34.7791L37.802 25.7965H33.5555H31.7355L40.8352 34.7791Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7364 3.04031L36.0184 3.04028L36.0184 23.9994L37.8028 25.7963H36.0184H31.7363L31.7364 3.04031Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.5859,
    y: 2.81006,
    width: 2.84657,
    height: 2.80996,
    transform: "rotate(-180 29.5859 2.81006)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4648,
    y: 23.2625,
    width: 1.72661,
    height: 1.65833,
    transform: "rotate(-180 28.4648 23.2625)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2285,
    y: 10.4983,
    width: 3.34763,
    height: 3.30457,
    transform: "rotate(-180 23.2285 10.4983)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2285,
    y: 17.1062,
    width: 3.34763,
    height: 3.30457,
    transform: "rotate(-180 23.2285 17.1062)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5781,
    y: 13.8018,
    width: 3.34763,
    height: 3.30457,
    transform: "rotate(-180 26.5781 13.8018)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8848,
    y: 13.8018,
    width: 3.34763,
    height: 3.30457,
    transform: "rotate(-180 19.8848 13.8018)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1198_6591",
    x1: 28.4372,
    y1: 2.81838,
    x2: 28.4372,
    y2: 46.7498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F22F81",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/WhiteLogo.762fd31c21fa0bff87fa3511041e02c8.svg";
export { ForwardRef as ReactComponent };